var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.statusDetails)?_c('div',{staticClass:"badge",style:(`background-color: ${_vm.statusDetails.color}`)},[_vm._v(" "+_vm._s(_vm.statusDetails.label)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }